<template>
    <v-container fluid>
        <v-card flat class="px-2">
            <v-card-title class="escalation-matrix d-flex justify-space-between">
              <span>Update Matrix</span>
              <span>
                <v-btn
                  dense
                  elevation="0"
                  small
                  :to="{name: 'matrixList'}"
                >
                    <v-icon small>mdi-chevron-left</v-icon>
                    Back
                </v-btn>
              </span>
            </v-card-title>
            <form @submit.prevent="editMatrixCOnfiguration">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="4" lg="4" xs="12" sm="4">
                            <v-text-field
                                v-model="selectedQueryRelatedToName"
                                dense
                                outlined
                                hide-details
                                readonly
                                required
                            >
                                <template v-slot:label>
                                    queryRelatedTo/Department
                                    <span class="error--text">*</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" lg="4" xs="12" sm="4">
                            <v-text-field
                                v-model="selectedQueryTypeName"
                                dense
                                outlined
                                hide-details
                                readonly
                                required
                            >
                                <template v-slot:label>
                                    queryType/ Catergory
                                    <span class="error--text">*</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" lg="4" xs="12" sm="4">
                            <v-text-field
                                v-model="selectedLevelName"
                                dense
                                outlined
                                hide-details
                                readonly
                                required
                            >
                                <template v-slot:label>
                                    Level
                                    <span class="error--text">*</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" lg="4" xs="12" sm="4">
                            <v-text-field
                                v-model="selectedZoneName"
                                dense
                                outlined
                                hide-details
                                readonly
                                required
                            >
                                <template v-slot:label>
                                    Zone
                                    <span class="error--text">*</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" lg="8" xs="12" sm="8">
                            <v-text-field
                                v-model="emailId"
                                type="email"
                                dense
                                hide-details
                                outlined
                                required
                            >
                                <template v-slot:label>
                                    Email
                                    <span class="error--text">*</span>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn type="submit" color="accent" dense small>Update Matrix</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-container>
</template>
<script>
import CONSTANTS from '@/utils/constants'
export default {
  name: 'updateMatrix',
  data () {
    return {
      queryRelatedTo: [],
      queryType: [],
      level: [],
      zone: [],
      selectedQueryRelatedToID: null,
      selectedQueryRelatedToName: null,
      selectedQueryTypeId: null,
      selectedQueryTypeName: null,
      selectedLevelId: null,
      selectedLevelName: null,
      selectedZoneId: null,
      selectedZoneName: null,
      emailId: null
    }
  },
  async created () {
    await this.getMatrixDetailsById()
  },
  methods: {
    editMatrixCOnfiguration: async function () {
      try {
        if (this.emailId) {
          let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!this.emailId.match(reg)) {
            this.$dialog.error({
              title: 'Invalid Email',
              text: 'Please enter valid email id.'
            })
            return false
          }
        }
        let payload = {}
        payload.queryRelatedToId = this.selectedQueryRelatedToID
        payload.queryTypeId = this.selectedQueryTypeId
        payload.emailId = this.emailId
        payload.levelId = this.selectedLevelId
        payload.zoneId = this.selectedZoneId
        payload.zoneName = this.selectedZoneName
        payload.id = this.$route.params.id
        let res = await http.post(`${CONSTANTS.API_URL}/api/sbTicketing/update-user`, payload)
        if (res.status === 200) {
          this.$router.push({ name: 'matrixList' })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getMatrixDetailsById: async function () {
      try {
        const id = this.$route.params.id
        let res = await http.get(`${CONSTANTS.API_URL}/api/sbTicketing/getMatrixDetailsById/${id}`)
        if (res.status === 200) {
          if (res.status) {
            this.selectedQueryRelatedToID = res.data.queryRelatedTo.sbID
            this.selectedQueryRelatedToName = res.data.queryRelatedTo.name
            this.selectedQueryTypeId = res.data.queryType.sbID
            this.selectedQueryTypeName = res.data.queryType.name
            this.selectedLevelId = res.data.level.id
            this.selectedLevelName = res.data.level.name
            this.selectedZoneId = res.data.zone.id
            this.selectedZoneName = res.data.zone.name
            this.emailId = res.data.emailId
          } else {
            return this.$dialog.error({
              title: 'Error',
              text: res.msg
            })
          }
        }
      } catch (err) {
        const errorMessage = (err && err.response && err.response.data.message) || err.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    }
  }
}
</script>
